<!--
* UIID: UI-DLB-RMG-110
* UI Name: SRM List in Repository List
* Modify Date: 2020/07/07
-->
<template>
  <div class="srm-list-container">
    <!-- Condition Search & Button -->
    <v-row class="custom-form-control custom-form-control-type-2">
      <v-col class="pb-0 pt-0" cols="12">
        <!-- Condition Search -->
        <v-row>
          <v-col class="comm-header-col data-query-section pb-0 pt-0" cols="12" lg="6">
            <v-row>
              <v-col cols="12" md="3" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="masterSearchItems.data[0].CUST_ID"
                  :items="customerItem"
                  :menu-props="{ offsetY: true }"
                  :placeholder="$t('lbl.common.conditionSearch.selectCustomer')"
                  @change="queryList"
                  class="custom-selectbox"
                  hide-details
                  dense
                  solo
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_SNDR"
                  @keyup.enter="queryList"
                  :placeholder="$t('lbl.common.conditionSearch.findbySender')"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_RCVR"
                  :placeholder="$t('lbl.common.conditionSearch.findbyReceiver')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_ID"
                  :placeholder="$t('lbl.common.conditionSearch.findbyMessage')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="pt-0 pb-0 pr-24px">
                <v-autocomplete
                  v-model="masterSearchItems.data[0].PRCS_STS"
                  :items="srmStatusSearchArr"
                  :menu-props="{ offsetY: true }"
                  :placeholder="$t('lbl.common.conditionSearch.selectStatus')"
                  @change="queryList"
                  class="custom-selectbox"
                  hide-details
                  dense
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 text-right"
            cols="12"
            lg="6"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-label>{{ $t("lbl.repositoryManager.updateDate") }}</v-label>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromdate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.FR_DAT"
                    :placeholder="$t('lbl.common.fromDate', [dateTimeFormat])"
                    :error-messages="masterSearchItems.init.FR_DAT_ERROR"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.init.FR_DAT"
                  @input="fromdate_menu = false; changeDate('from')"
                  :max="getMaxDate"
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">
                    {{$t("btn.common.cancel")}}
                  </v-btn>
                  <v-btn
                    @click="$refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)"
                    text
                    color="primary"
                  >{{ $t("btn.common.ok") }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="todate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.TO_DAT"
                    :error-messages="masterSearchItems.init.TO_DAT_ERROR"
                    :placeholder="$t('lbl.common.toDate', [dateTimeFormat])"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :allowed-dates="allowedDates"
                  v-model="masterSearchItems.init.TO_DAT"
                  @input="todate_menu = false; changeDate('to')"
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">
                    {{
                    $t("btn.common.cancel")
                    }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.todate_menu.save(masterSearchItems.init.TO_DAT)"
                  >{{ $t("btn.common.ok") }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <div class="button-group-div">
                <v-btn
                  @click.native="queryList"
                  class="search-data-analysis-button btn-height-custom btn-width-1 btn-search primary mb-0"
                >
                  <v-icon x-small class="mr-2">fa fa-search</v-icon>
                  {{ $t("btn.common.search") }}
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Button Action (Add/ Delete...)-->
    <!-- // 2021.11.26 203728 SPKA-274 modify paging -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-tooltip top :disabled="!isEnableCopyToRepo" :max-width="tooltipWidth">
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="btn-tooltip">
                      <v-btn
                        @click="copyToRepository"
                        :disabled="isEnableCopyToRepo"
                        class="btn btn-add"
                      >
                        <v-icon x-small class="mr-2">fa fa-object-ungroup</v-icon>
                        {{ $t("btn.repositoryManager.srmList.copyRepository") }}
                      </v-btn>
                    </div>
                  </template>
                  <span>
                    {{$t("msg.repositoryManager.srmTab.copyRepoTooltipMsg")}}
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>

          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  height="30"
                  hide-details
                  dense
                  solo
                  @change="onFilterSRM"
                  :items = searchByItems
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="search"
                  heigth="30"
                  append-icon="fa fa-search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  @input="onFilterSRM"
                  @click:append="onFilterSRM"
                  @keyup.enter="onFilterSRM"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-table
          ref="srm_repo_list_table"
          is-horizontal-resize
          is-vertical-resize
          width="100%"
          :key="componentKey"
          :height="tableHeight"
          :isMinHeight="isMinHeight"
          :title-rows="titleRows"
          :columns="columns"
          :table-data="srmList"
          :row-class-name="setRowClassName"
          :title-row-height="$vuetify.theme.dark ? 45 : 41"
          :border-header-height="$vuetify.theme.dark ? 0 : 4"
          :row-height="35"
          :select-all="selectAllChange"
          :select-change="selectItemChange"
          :class="$vuetify.theme.dark
              ? 'v-search-list-table-merge srm-list-table repo-list-table'
              : 'v-search-list-table-merge srm-list-table repo-list-table border-top'
          "
          :errorContent="'No matching records found'"
          :cell-merge="cellMerge"
          :multiple-sort="false"
          @sort-change="sortChange"
          :after-update-callback="afterUpdateTable"
          :paging-index="(page-1)*itemsPerPage"
          :row-click="rowClick"
          :row-mouse-enter="rowEnter"
          :row-mouse-leave="rowLeave"
        >
          <template v-slot:MST_CUST_NM="{ item }">
            <span>{{ item.MST_CUST_NM }}</span>
          </template>
          <template v-slot:SRM_SNDR="{ item }">
            <span>{{ item.SRM_SNDR }}</span>
          </template>
          <template v-slot:SRM_RCVR="{ item }">
            <span>{{ item.SRM_RCVR }}</span>
          </template>
          <template v-slot:SRM_MSG_ID="{ item }">
            <span>{{ item.SRM_MSG_ID }}</span>
          </template>
          <template v-slot:SRM_PRCS_STS_NM="{ item }">
            <v-text-field
              v-model="item.SRM_PRCS_STS_NM"
              :class="[
                srmStatusClass(item),
                'data-table-select-box',
                'srm-select-box',
                'custom-selectbox',
                'communication-select-box',
                'pt-1',
              ]"
              placeholder="Select"
              height="30"
              hide-details
              dense
              solo
              outlined
              readonly
            ></v-text-field>
          </template>
          <template v-slot:ATF_FILE_NAME="{ item }">
            <a class="download-attach-file-text" @click="downloadAttachFile(item)">
              {{
              item.ATF_FILE_CNT > 1
              ? item.ATF_FILE_NAME +`(+${item.ATF_FILE_CNT - 1} ${item.ATF_FILE_CNT - 1 > 1 ? "Files" : "File"})`
              : item.ATF_FILE_NAME
              }}
            </a>
          </template>
          <template v-slot:layout="{ item }">
            <a v-if=" item.LAY_MSG_ID != null &&
                      item.LAY_MSG_VER != null &&
                      item.LAY_PRCS_NO != null"
                      @click="openLayoutView(item)"
                      >{{ $t("btn.common.view") }}</a>
          </template>
          <template v-slot:merge_layout="{ item }">
            <a v-if=" item.LAY_MSG_ID != null &&
                      item.LAY_MSG_VER != null &&
                      item.LAY_PRCS_NO != null"
                      @click="openLayoutView(item)"
                      >{{ $t("btn.common.view") }}</a>
          </template>
          <template v-slot:merge_FFL_FILE_NAME="{ item }">
            <span class="font-weight-bold">{{ item.FFL_FILE_NAME }}</span>
          </template>
          <template v-slot:merge_MPD_FILE_NAME="{ item }">
            <span class="font-weight-bold">{{ item.MPD_FILE_NAME }}</span>
          </template>
          <template v-slot:merge_MAP_NAME="{ item }">
            <span class="font-weight-bold">{{ item.MAP_NAME }}</span>
          </template>
        </v-table>
      </v-col>
    </v-row>

    <!-- // 2021.11.26 203728 SPKA-274 modify paging -->
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0 pl-1" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    @change="handlePageSizeChange"
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox">
                  </v-select>
                </div>
                <div class="page-showing">
                  <v-label>
                    {{ (itemsPerPage * (page-1)) +1 }} ~ {{ totalCnt - itemsPerPage*page > 0 ? itemsPerPage*page : totalCnt }} of {{totalCnt}}
                  </v-label>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
              <!-- 2021.11.23 203728 SPKA-260 first prev button -->
                <button type="button" @click="handlePageChange(1)" :class="['custom-btn-first-last-paging', page == 1 ? ' v-pagination__navigation--disabled': '']">
                  <div class="ml-2 pr-2 d-inline"><span><i class="fa fa-sm fa-step-backward"></i></span></div>
                </button>
                <button type="button" @click="changePageByTextbox(-1)" :class="['mr-3 custom-btn-first-last-paging', page-1 < 1 ? ' v-pagination__navigation--disabled': '']">
                  <div class="ml-2 pr-2 d-inline"><span><i class="fa fa-lg fa-caret-left"></i></span></div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field><label>/ {{pageCount}}</label>
                <button type="button" @click="changePageByTextbox(1)" :class="['ml-3 custom-btn-first-last-paging', page+1 > pageCount ? ' v-pagination__navigation--disabled': '']">
                    <div class="mr-2 pl-2 d-inline"><span><i class="fa fa-lg fa-caret-right"></i></span></div>
                  </button>
                <button type="button" @click="handlePageChange(pageCount)" :class="['custom-btn-first-last-paging', page == pageCount ? ' v-pagination__navigation--disabled': '']">
                    <div class="mr-2 pl-2 d-inline"><span><i class="fa fa-sm fa-step-forward"></i></span></div>
                  </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs"></div>
    <dialogWindow
      ref="SearchCondition"
      :detail="$t('msg.common.fromDateValidate')"
      size="max"
      title="Search"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail='$t("msg.common.validateDate")'
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import { mapState } from "vuex";
import $ from "jquery";
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';
import cfg from '@/vue-caas/config/config.js'

export default {
  components: {
    dialogWindow
  },

  computed: {
    ...mapState("common", {
        codeList: "codeList"
    }),
    ...mapState("repository", {
        srmList: "srmList",
        srmListSource: "srmListSource",
        arrFilter: "arrFilter",
        repoList:"allRepoList",
        totalCnt : "totalCnt",
    }),

    getMaxDate () {
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        return getAppliedTimeZone();
      }
      else {
        this.$refs.SearchCondition.dialog = true;
        return getAppliedTimeZone();
      }
    },
    getMinDate () {
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        return this.masterSearchItems.init.FR_DAT;
      }
      else {
        this.$refs.SearchCondition.dialog = true;
        return this.masterSearchItems.init.FR_DAT;
      }
    },
    // 203665 Apply disable/enalble button and tooltip
    isEnableCopyToRepo(){
      if(this.selectMasterRows.length <1 ){
        return true;
      }else{
        for(let i = 0; i < this.selectMasterRows.length; i++) {
          for(let j=0;j<this.repoList.length; j++){
            if(this.selectMasterRows[i].SRM_SNDR == this.repoList[j].REPO_SNDR && this.selectMasterRows[i].SRM_RCVR == this.repoList[j].REPO_RCVR && this.selectMasterRows[i].SRM_MSG_ID == this.repoList[j].REPO_MSG_ID  && this.selectMasterRows[i].OWNR_CUST_ID == this.repoList[j].OWNR_CUST_ID){
                return true;
            }
          }
        }
        return false;
      }
    }
  },
  props: ['changeTab'],
  data(){
    return{
    rowCheck:[],
    fromdate_menu: false,
    todate_menu: false,
    search: '',
    dialog: false,
    tab: null,
    tooltipWidth: 300,
    dateTimeFormat: '',
    isMinHeight:true,
    tableHeight:540,
    componentKey:0,
    window: {
      width: 0,
      height: 0
    },
    items: [
      { tab: 'repository', content: 'Repository' },
      { tab: 'srm_list', content: 'SRM List' },
    ],
       // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    codeSearchItems: {
      header: ['GRP_CODE'],
      data: [{
        GRP_CODE:'',
      }],
    },
    columns: [
      {field: 'custome', width: 47, customSlot: true, checkShow : true, isShowSelect: (item) => { return item.SYSSTATUS != 'I' && item.SRM_PRCS_STS_NM != 'Repository' }, titleAlign: 'center',columnAlign:'center',type: 'selection', isFrozen:  true},
      {field: 'MST_CUST_NM', width: 100, customSlot: true, className:"font-weight-bold frozen-col-bg", columnAlign: 'left', isFrozen:  true},
      {field: 'SRM_SNDR', width: 100, customSlot: true, className:"sender-col frozen-col-bg", columnAlign: 'left', isFrozen:  true},
      {field: 'SRM_RCVR', width: 100, customSlot: true, className:"receiver-col frozen-col-bg", columnAlign: 'left', isFrozen:  true},
      {field: 'SRM_MSG_ID', width: 100, customSlot: true, className:"message-col frozen-col-bg", columnAlign: 'center', isFrozen:  true},
      {field: 'SRM_PRCS_STS_NM', width: 150, columnAlign: 'center', customSlot: true, className:"status-col frozen-col-bg", isFrozen:  true},
      {field: 'layout', width: 93, className: "layout-col frozen-col-bg", customSlot: true, columnAlign: 'center' },
      {field: 'MAP_NAME', width: 200, className: "map-name-col", customSlot: true, columnAlign: 'left'},
      {field: 'FFL_FILE_NAME', width: 300, className:"font-weight-bold", columnAlign: 'left'},
      {field: 'MPD_FILE_NAME', width: 300, className:"font-weight-bold", columnAlign: 'left'},
      {field: 'ATF_FILE_NAME', width: 300, className: "map-name-col", customSlot: true, columnAlign: 'left'},
      {field: 'SRM_UPD_DT', width: 168, className: "update-date-col", columnAlign: 'center' },
      {field: 'SRM_UPD_USR', width: 158, className: "update-user-col", columnAlign: 'center' },
    ],
    titleRows: [[
      {fields: ['custome'], title: '', titleAlign: 'center'},
      {fields: ['MST_CUST_NM'], title: 'Customer',orderBy : '', titleAlign: 'center', newprop: 'newprop'},
      {fields: ['SRM_SNDR'], title: 'Sender',orderBy : '', titleAlign: 'center', newprop: 'newprop'},
      {fields: ['SRM_RCVR'], title: 'Receiver', titleAlign: 'center'},
      {fields: ['SRM_MSG_ID'], title: 'Message', titleAlign: 'center'},
      {fields: ['SRM_PRCS_STS_NM'], title: 'Status', titleAlign: 'center'},
      {fields: ['layout'], title: 'Layout', titleAlign: 'center'},
      {fields: ['MAP_NAME'], title: 'Map', titleAlign: 'center'},
      {fields: ['FFL_FILE_NAME'], title: 'FlatFile Layout', titleAlign: 'center'},
      {fields: ['MPD_FILE_NAME'], title: 'Mapping Definition', titleAlign: 'center'},
      {fields: ['ATF_FILE_NAME'], title: 'Reference Files', titleAlign: 'center'},
      {fields: ['SRM_UPD_DT'], title: 'Update Date', titleAlign: 'center', orderBy: ""},
      {fields: ['SRM_UPD_USR'], title: 'Update User', titleAlign: 'center'}
      ]
    ],
    masterSearchItems: {
      header: ['ADMIN_YN','CUST_ID', 'OWNR_CUST_ID', 'MSG_SNDR','MSG_RCVR','MSG_ID','DAT_TYPE','FR_DAT','TO_DAT', 'PRCS_STS','PAGE_NUMBER','PAGE_SIZE'],
      data: [{
        ADMIN_YN:'',
        CUST_ID: '',
        OWNR_CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        PRCS_STS: '',
        PAGE_NUMBER: '',
        PAGE_SIZE: ''
      }],
      init: {
        DAT_TYPE: '',
        FR_DAT: beforeOneMonth(),
        TO_DAT: getAppliedTimeZone(),
        FR_DAT_PREV: beforeOneMonth(),
        TO_DAT_PREV: getAppliedTimeZone(),
        FR_DAT_ERROR: [],
        TO_DAT_ERROR: []
      }
    },
    repoSearchItems: {
      header: ['ADMIN_YN','CUST_ID', 'OWNR_CUST_ID', 'MSG_SNDR','MSG_RCVR','MSG_ID','DAT_TYPE','FR_DAT','TO_DAT', 'PRCS_STS'],
      data: [{
        ADMIN_YN:'',
        CUST_ID: '',
        OWNR_CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        DAT_TYPE: 'UPDT',
        FR_DAT: '',
        TO_DAT: '',
        PRCS_STS: ''
      }],
    },
    openLayoutViewItems: {
      header: ['CUST_ID', 'OWNR_CUST_ID', 'STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','MSG_CNT','MAP_NAME','FFL_FILE_NAME','MAP_CONV_TP'],
      data: [{
        CUST_ID: '',
        OWNR_CUST_ID: '',
        STR_SNDR: '',
        STR_RCVR: '',
        MSG_STD: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        MSG_CNT: '',
        FFL_FILE_NAME: '',
        MAP_NAME:'',
        MAP_CONV_TP: ''
      }]
    },
    copyToRepositoryItems: {
      header: ['ADMIN_YN', 'OWNR_CUST_ID', 'SRM_PRCS_NO'],
      data: [{
        ADMIN_YN: '',
        OWNR_CUST_ID: '',
        SRM_PRCS_NO: '',
      }]
    },
    downloadReferenceHeader: {
      header: ['SRM_PRCS_NO'],
      data: [
        {SRM_PRCS_NO: ''}
      ]
    },
    searchBy: '',
    searchByItems: [
      { text: 'Customer', value: 'MST_CUST_ID',},
      { text: 'Sender', value: 'SRM_SNDR', },
      { text: 'Receiver', value: 'SRM_RCVR' },
      { text: 'Message', value: 'SRM_MSG_ID' },
      { text: 'Map', value: 'MAP_NAME' },
      { text: 'FlatFile Layout', value: 'FFL_FILE_NAME' },
    ],
    srmStatusSearchArr: [
      {text:'Select All', value : 'all'},
    ],
    customerItem:[
      {text:'Select All', value : ''},
    ],
    selectedMasterItem : {},
    arrLayoutDialog: [],
    dialogs: [],
    dialogId: 1,
    selected: null,
    selectMasterRows: [],
    layoutViewArr: [],
    statusStatArr: [],
    srmStatusArr: [],
    page: 1,
    pageCount: 0,
    isFilter: false,
    pageList:[
      {value: 1, text: 'Page 1'},
    ],
    itemsPerPage: 25,
    pageEnter: 1,// 2021.11.26 203728 SPKA-274 modify paging
    rowPerPage: [
      {value: 10, text: 'Show 10'},
      {value: 25, text: 'Show 25'},
      {value: 50, text: 'Show 50'},
      {value: 75, text: 'Show 75'},
      {value: 100, text: 'Show 100'}
    ],
    // 2021.9.9 203728 SPKA-199 Change background when hover,click row in v-table
    rowCurrentClick: -1,
    listFrozen: ['MST_CUST_NM', 'SRM_SNDR', 'SRM_RCVR', 'SRM_MSG_ID', 'SRM_PRCS_STS_NM', 'layout'],
  }},
  watch: {
    changeTab(){
      if(this.changeTab!=0){
        this.queryList();
      }
    },
    // 2021.11.26 203728 SPKA-274 modify paging
    page(){
      this.pageEnter = this.page;
    }
  },
  methods: {
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if(!dateString.match(regEx)) return false;  // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0,10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = (side === 'from') ? this.masterSearchItems.init.FR_DAT: this.masterSearchItems.init.TO_DAT
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if ((charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 4 && !dateString.includes("-")) || 
      (charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 7 && dateString[4] === '-' && ((dateString.match(/-/g) || []).length == 1))) {
        dateString += '-';
        (side === 'from') ? (this.masterSearchItems.init.FR_DAT = dateString) : (this.masterSearchItems.init.TO_DAT = dateString)
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if(!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT
        }
      }
      if (side === 'to') {
        if(!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT
        }
      }
    },
    // 2021.11.26 203728 SPKA-281 process change page by input textbox
    changePageByTextbox(value){
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : (data < 1 ? 1 : data);
        this.pageEnter = this.page;
      }
      this.page += value;
      this.handlePageChange(this.page);
    },
    // 2021.9.89 203728 SPKA-199 Change background when hover,click row in v-table
    rowClick(rowIndex, rowData){
      this.listFrozen.map(e => {
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      })
      this.rowCurrentClick = rowIndex;
    },
    rowEnter(rowIndex){
      this.listFrozen.map(e => {
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      })
    },
    rowLeave(rowIndex){
      if(this.rowCurrentClick !== rowIndex){
        this.listFrozen.map(e => {
          $('#' + e + rowIndex).removeClass('custom-row-click-v-table');
        })
      }
    },
    getStatus(){
      this.codeSearchItems.data[0].GRP_CODE ="A05";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => {
          console.log("--------- Finished to process Status List ----------");
          for(let i=0;i< this.codeList.length;i++){
          let codeObj= {};
          codeObj.text= this.codeList[i].CM_CODE_NAME;
          codeObj.value= this.codeList[i].CM_CODE_ID;
          this.srmStatusSearchArr.push(codeObj);
          this.srmStatusArr.push(codeObj);
          }
        });
    },
    getCustomers(){
      this.$store.dispatch('getCompanyList').then(()=>{
        console.log("--------- Finished to process Customer List ----------");
        this.$store.getters.companies.forEach(element => {
          let codeObj = {};
          codeObj.text = element.compNm;
          codeObj.value = element.compId;
          this.customerItem.push(codeObj);
        });
      });
    },
    queryList (pageChange) {
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        console.log("--------- getSummaryList ----------");
        this.masterSearchItems.data[0].FR_DAT = deleteDateFormatStr(this.masterSearchItems.init.FR_DAT);
        this.masterSearchItems.data[0].TO_DAT = deleteDateFormatStr(this.masterSearchItems.init.TO_DAT);
        this.masterSearchItems.data[0].ADMIN_YN = $cookies.get('used-repo');
        this.masterSearchItems.data[0].OWNR_CUST_ID = $cookies.get('ownr-id');
        this.masterSearchItems.data[0].DAT_TYPE = this.masterSearchItems.init.DAT_TYPE;
        if(this.masterSearchItems.data[0].PRCS_STS == "all"){
          this.masterSearchItems.data[0].PRCS_STS = '';
        }
        this.masterSearchItems.data[0].PAGE_NUMBER = this.page;
        this.masterSearchItems.data[0].PAGE_SIZE = this.itemsPerPage;
        Store.dispatch("repository/querySRMList", this.masterSearchItems).then(() => {
         //console.log(JSON.stringify(this.srmList))
          console.log("--------- Finished to process ----------");
          /*
          203665 Update pagination for SRM list repository manager issue 35
          */
          if(this.totalCnt % this.itemsPerPage == 0){
            this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage);
          }else{
            this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
          }
          if(pageChange == 'pageChange' && this.pageCount < this.page){
            this.page = 1;
          }
          this.createPageList(this.pageCount);
          this.selectMasterRows = [];
        });
        this.quickSearch = "";
      } else {
        this.$refs.SearchCondition.dialog = true;
      }
    this.queryRepoList();
    },
    queryRepoList () {
      this.repoSearchItems.data[0].ADMIN_YN = $cookies.get('used-repo');
      this.repoSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
      this.repoSearchItems.data[0].OWNR_CUST_ID = $cookies.get('ownr-id');
      Store.dispatch("repository/queryAllRepoList", this.repoSearchItems).then(() => {
        console.log("--------- Finished to process ----------");
        this.selectMasterRows = [];
      });
      this.quickSearch = "";
    },

    cellMerge(rowIndex,rowData,field){
      if (field == 'custome' || field == 'layout' || field == 'MAP_NAME' || field == 'FFL_FILE_NAME' || field == 'MPD_FILE_NAME') {
        let filters = this.arrFilter.filter((item) => {
          return item.index == rowIndex;
        });
        if (filters.length == 1) {
          let filter = filters[0];
          return {
              colSpan: 1,
              rowSpan: filter.count,
              content: '',
              componentName: ''
          }
        }
      }
    },

    openLayoutView(item) {
      let index = this.layoutViewArr.findIndex(e => e.ROWID === item.ROWID);
      if (index > -1) return window.layoutFocus[item.ROWID]();

      this.openLayoutViewItems.data[0].CUST_ID  = $cookies.get('comp-id');
      this.openLayoutViewItems.data[0].OWNR_CUST_ID  = $cookies.get('ownr-id');
      this.openLayoutViewItems.data[0].MSG_STD  = item.LAY_MSG_STD;
      this.openLayoutViewItems.data[0].MSG_ID  = item.LAY_MSG_ID;
      this.openLayoutViewItems.data[0].MAP_NAME  = item.MAP_NAME;
      this.openLayoutViewItems.data[0].MAP_CONV_TP  = item.MAP_CONV_TP;
      this.openLayoutViewItems.data[0].FFL_FILE_NAME  = item.FFL_FILE_NAME;
      this.openLayoutViewItems.data[0].FFL_FRMT_TP  = item.FFL_FRMT_TP;
      this.openLayoutViewItems.data[0].MSG_VER  = item.LAY_MSG_VER;
      this.openLayoutViewItems.data[0].STR_SNDR =  item.SRM_SNDR;
      this.openLayoutViewItems.data[0].STR_RCVR =  item.SRM_RCVR;
      this.openLayoutViewItems.data[0].MSG_CNT = item.ATF_FILE_CNT;
      this.openLayoutViewItems.data[0].DAT_TYPE  = this.masterSearchItems.data[0].DAT_TYPE;
      this.openLayoutViewItems.data[0].FR_DAT = this.masterSearchItems.data[0].FR_DAT;
      this.openLayoutViewItems.data[0].TO_DAT = this.masterSearchItems.data[0].TO_DAT;
      this.openLayoutViewItems.data[0].PRCS_STS = item.SRM_PRCS_STS;
      this.openLayoutViewItems.data[0].LAY_PRCS_NO = item.LAY_PRCS_NO;
      this.openLayoutViewItems.data[0].SRM_PRCS_NO = item.SRM_PRCS_NO;
      this.openLayoutViewItems.data[0].ALIAS = '';
      this.openLayoutViewItems.data[0].ROWID = item.ROWID;

      this.params = this.openLayoutViewItems.data[0];

      this.layoutViewArr.push(item);
      Store.commit('layout/SET_LAYOUT_WINDOW_PARAM', Object.assign({}, this.params));

      var w = window.open(`/edimanager/EdiAnalyzedView_SRM/${item.ROWID}`, '_blank', "width=1550,height=800,left=100,top=30");
      w.mode = "RepositoryLayoutView";
      if(this.$vuetify.theme.isDark == true){
            w.theme = this.$vuetify.theme.isDark;
      }
      w.params = this.params;
      // 20218.7.13 203728 SPKA-153 close new window expired.
      w.newWindowExpire = true;
      w.parent = this;// 2021.4.12 203728 SPKA-52 => bug 16
      w.closePopup = () => {
        let index = w.parent.findIndexItem(item, w.parent.layoutViewArr, 'ROWID');
        w.parent.layoutViewArr.splice(index, 1);
        Store.commit('layout/DELETE_LAYOUT_WINDOW_PARAM', Object.assign({}, w.parent.params));
        w.close();
        for (let i = 0; i < w.parent.selectMasterRows.length; i++) {
           w.parent.selectMasterRows[i]._checked = false;
        }
        w.parent.$refs.srm_repo_list_table.updateCheckboxStatus();
        w.parent.selectMasterRows = [];
        w.parent.queryList();
      }
      w.focusPopup = () => {
        w.focus();
      }
      if (typeof window.layoutOpenWindow == 'undefined' || typeof window.layoutFocus == 'undefined') {
        window.layoutOpenWindow = {[item.ROWID.toString()] : w.closePopup};
        window.layoutFocus = {[item.ROWID.toString()] : w.focusPopup};
      } else {
        window.layoutOpenWindow[item.ROWID.toString()] = w.closePopup;
        window.layoutFocus[item.ROWID.toString()] = w.focusPopup;
      }
      w.onbeforeunload = w.closePopup;
    },

    copyToRepository() {
      // 203665 Apply disable/enalble button and tooltip
      this.copyToRepositoryItems.data = [];
      for(let i = 0; i < this.selectMasterRows.length; i++) {
        let item = this.selectMasterRows[i];
        this.copyToRepositoryItems.data.push({
          ADMIN_YN : $cookies.get('used-repo'),
          OWNR_CUST_ID : $cookies.get('ownr-id'),
          SRM_PRCS_NO : item.SRM_PRCS_NO,
        })
      }
      Store.dispatch("repository/copyToRepository", this.copyToRepositoryItems).then(() => {
        console.log("--------- Finished to process ----------");
         for (let i = 0; i < this.selectMasterRows.length; i++) {
           this.selectMasterRows[i]._checked = false;
        }
        this.$refs.srm_repo_list_table.updateCheckboxStatus();
        this.queryList();
        this.queryRepoList();
        this.selectMasterRows = [];
      });

    },
    onFilterSRM(str) {
      // 2021.9.10 203728 SPKA-199 Clear select row
      this.$refs.srm_repo_list_table.clearCurrentRow();
      this.rowCurrentClick = -1;
       this.isFilter = true;
        if(this.searchBy =='' && this.search == ''){
          this.isFilter = false;
      }
      let datarows = this.srmListSource;
      let filterBy = {filter : this.searchBy, str : this.search};
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult=datarows;
        }
        listResult = datarows.filter(item =>  {
          if(filter == '') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
          return false;
        });
      }
      Store.commit('repository/srmListFilter', listResult);
    },

    /*
    203665 Update pagination for SRM list repository manager issue 35
    */
    handlePageChange(value) {
      this.page = value;
      this.queryList('pageChange');
    },

    handlePageSizeChange(size) {
      this.itemsPerPage = size;
      this.page = 1;
      this.queryList();
    },
    createPageList(pageCount){
      this.pageList=[];
      for( let i=1;i<pageCount+1;i++){
        let obj = {};
        obj.text = 'Page '+i;
        obj.value = i;
        this.pageList.push(obj);
      }
    },

    afterUpdateTable() {
      setTimeout(() => {
        let scrollbar = $('.v-scrollbar-wrap').first();
        let scrolltop = scrollbar.scrollTop();
        scrollbar.scrollTop(scrolltop - 1);
        scrollbar.scrollTop(scrolltop + 1);
        scrollbar.scrollTop(scrolltop);
      }, 3);
    },

    srmStatusClass(item) {
      if(typeof item.SRM_PRCS_STS == 'string') {
        if (item.SRM_PRCS_STS_NM === 'Repository') {
           return `srm-cl-select-box-status`;
        }
        return `srm-${item.SRM_PRCS_STS.toLowerCase()}-select-box-status`;
      }
    },
    selectItemChange(selection,rowData) {
      this.selectMasterRows=selection;
      console.log(this.selectMasterRows);
    },
    selectAllChange(selection) {
      var tempElement = ''
      var _selection = [];
      if (selection.length > 0) {
        do {
          tempElement = selection.shift();
          _selection.push(tempElement);
          selection = selection.filter(val => {
            return tempElement.LAY_PRCS_NO != val.LAY_PRCS_NO;
          })
        } while (selection.length != 0)
      } else {
        _selection = selection;
      }
      this.selectMasterRows = _selection;
    },
    findIndexItem(item, arr) {
      let index = arr.findIndex((row) => {
        return row.id === item.id
      })
      return (index > -1) ? index : null
    },

    downloadAttachFile(srmitem) {
      this.downloadReferenceHeader.data[0].SRM_PRCS_NO = srmitem.SRM_PRCS_NO;
      Store.dispatch("srmlist/downloadAllReferenceFiles", this.downloadReferenceHeader ).then(() => {
        console.log("--------- Finished to process ----------");
      });
    },
    setRowClassName(index, item) {
      if(item['hidden']) {
        return 'd-none';
      }
    },

    newDialog (item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },

    removeDialog (dialog) {
      let id = dialog.id
      let index = this.findDialog(id)
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1)
      if (this.selected && this.selected.id === id) this.selected = null
    },

    findDialog (id, dialogs) {
      if (!dialogs) dialogs = this.dialogs
      let index = dialogs.findIndex((val) => {
        return val.id === id
      })
      return (index > -1) ? index : null
    },
    generateDialog (item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({id : id});
      this.dialogId++
      let name = 'Dialog ' + id
      let options = {left : 30 * this.dialogId, top : 30 * this.dialogId, item: item.item};
      return { id, name, type, options }
    },
    dialogDragEnd (obj) {
      let index = this.findDialog(obj.id)
      this.$set(this.dialogs[index].options, 'left', obj.left)
      this.$set(this.dialogs[index].options, 'top', obj.top)
    },
    selectDialog (obj) {
      let index = this.findDialog(obj.id)
      this.selected = this.dialogs[index]
    },
    sortChange(data) {
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        let col = keys[i];
        let sort = data[col];
        if (sort != "") {
          Store.commit('repository/sortSRMList', {col, sort});
          return;
        }
      }
    },
    allowedDates(val){
      let date= getAppliedTimeZone();
      if(val <= date){
        return val;
      }
    },
    /*
    203665 Update pagination for SRM list repository manager issue 35
    */
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if(this.window.width <= 1920 && this.window.width >= 1280){
        this.tableHeight = 540;
        if(this.$refs.srm_repo_list_table != undefined){
          this.$refs.srm_repo_list_table.initView();
          this.$refs.srm_repo_list_table.scrollControl();
          this.$refs.srm_repo_list_table.resize();
        }
        // this.componentKey+=1;
      }
      else if(this.window.width < 1280 && this.window.width >= 1024){
        this.tableHeight = 315;
        if(this.$refs.srm_repo_list_table != undefined){
          this.$refs.srm_repo_list_table.initView();
          this.$refs.srm_repo_list_table.scrollControl();
          this.$refs.srm_repo_list_table.resize();
        }
        // this.componentKey+=1;
      }
      else if(this.window.width < 1024){
        this.tableHeight = 155;
        if(this.$refs.srm_repo_list_table != undefined){
          this.$refs.srm_repo_list_table.initView();
          this.$refs.srm_repo_list_table.scrollControl();
          this.$refs.srm_repo_list_table.resize();
        }
        // this.componentKey+=1;
      }
    }

  },
    // Phong 08/06/2020 SRM_List_Test Result fix Issue 23

  created () {
    this.tooltipWidth= cfg.tooltipWidth;
    this.dateTimeFormat = cfg.dateTimeFormat;
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.queryList ();
    this.queryRepoList();
    this.getStatus();
    this.getCustomers();
  },
  mounted () {
    let a = $('.v-content__wrap');
    this.$nextTick(() => {
      console.log(this.headers);
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>
<style>
.theme--dark .srm-list-table .v-input input {
    color: #000000;
}
/* //2020-09-04: fix issue hoz table */
.srm-list-table{
  width: 100% !important;
}
</style>